// The Organization page's overview (A12U11, D183): every role opens it; each card shows only what the role reads.
import { createFileRoute } from '@tanstack/react-router'
import { membersQuery } from '../../../../features/members/queries'
import { OrgOverview } from '../../../../features/organization/OrgOverview'
import { orgQuery } from '../../../../features/settings/queries'
import { accessQuery } from '../../../../shared/access/access'
import { Part } from '../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/organization/')({
  staticData: { screenId: 'OrgHubScreen', access: 'member', ownHeader: true },
  loader: async ({ context: { queryClient, membership } }) => {
    await Promise.all([
      queryClient.ensureQueryData(orgQuery(membership.orgId)),
      queryClient.ensureQueryData(accessQuery(membership.orgId)),
      queryClient.ensureQueryData(membersQuery(membership.orgId)),
    ])
    return { orgId: membership.orgId }
  },
  component: OrgHubScreen,
})

function OrgHubScreen() {
  const { orgSlug } = Route.useParams()
  const { orgId } = Route.useLoaderData()
  return (
    <Part>
      <OrgOverview orgId={orgId} orgSlug={orgSlug} />
    </Part>
  )
}
